export enum CrmSettingsPath {
  INDEX = '',
  FORCE = '/required-customer',
  CRM_SETTINGS = '/crm-settings'
}
